import { render, staticRenderFns } from "./SectionRawDataTab.vue?vue&type=template&id=0848e05a&scoped=true&"
import script from "./SectionRawDataTab.vue?vue&type=script&lang=ts&"
export * from "./SectionRawDataTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848e05a",
  null
  
)

export default component.exports